export default {
	events: {
		'ddc.link.generic': [
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.includes('apply-for-financing'),
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'flex buy:content:apply for financing',
							onclickLinkName: '{client}:flex buy:content:action'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.includes('talk-to-a-specialist'),
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'flex buy:content:talk to a specialist',
							onclickLinkName: '{client}:flex buy:content:action'
						}
					}
				}
			},
			{
				logic: ({
					eventData: {
						attributes: { class: className }
					}
				}) => className.includes('start-your-application'),
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'flex buy:content:start your application',
							onclickLinkName: '{client}:flex buy:content:action'
						}
					}
				}
			}
		]
	}
};
